// YouTube API Service
// Using YouTube Media Downloader API

const RAPIDAPI_KEY = 'c49ee06b2fmsh6722d4fb13cbb5dp14ed9ejsn06c00c935147';
const RAPIDAPI_HOST = 'youtube-media-downloader.p.rapidapi.com';

export const downloadYouTubeVideo = async (url) => {
  try {
    const videoId = extractYouTubeVideoId(url);
    
    if (!videoId) {
      throw new Error('Invalid YouTube URL - could not extract video ID');
    }

    console.log('Fetching YouTube video:', videoId);
    
    const response = await fetch(
      `https://${RAPIDAPI_HOST}/v2/video/details?videoId=${videoId}`,
      {
        method: 'GET',
        headers: {
          'x-rapidapi-key': RAPIDAPI_KEY,
          'x-rapidapi-host': RAPIDAPI_HOST
        }
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error('API Error Response:', response.status, errorText);
      throw new Error(`API Error: ${response.status} - ${errorText}`);
    }

    const data = await response.json();
    console.log('YouTube API Response:', data);
    
    if (!data || data.error) {
      throw new Error(data.error || 'Invalid API response');
    }
    
    return data;
  } catch (error) {
    console.error('Error fetching YouTube video:', error);
    throw error;
  }
};

export const extractYouTubeVideoId = (url) => {
  // Extract video ID from various YouTube URL formats
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
    /^([a-zA-Z0-9_-]{11})$/
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }

  return null;
};

export const extractYouTubeVideoInfo = (apiResponse) => {
  console.log('Parsing YouTube response:', apiResponse);
  
  // Handle YouTube Media Downloader API response
  const videoId = apiResponse.id || apiResponse.videoId || '';
  const title = apiResponse.title || 'YouTube Video';
  
  // Handle author - it might be an object or string
  let author = 'Unknown';
  if (typeof apiResponse.channel === 'string') {
    author = apiResponse.channel;
  } else if (typeof apiResponse.channel === 'object' && apiResponse.channel?.name) {
    author = apiResponse.channel.name;
  } else if (typeof apiResponse.author === 'string') {
    author = apiResponse.author;
  } else if (typeof apiResponse.author === 'object' && apiResponse.author?.name) {
    author = apiResponse.author.name;
  }
  
  // Handle thumbnail
  let thumbnail = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  if (apiResponse.thumbnail) {
    if (Array.isArray(apiResponse.thumbnail) && apiResponse.thumbnail.length > 0) {
      thumbnail = apiResponse.thumbnail[apiResponse.thumbnail.length - 1].url;
    } else if (typeof apiResponse.thumbnail === 'string') {
      thumbnail = apiResponse.thumbnail;
    }
  }
  
  // Get video download links - check multiple possible locations
  let videoLink = null;
  let audioLink = null;
  
  // Check for videos array
  if (apiResponse.videos?.items && apiResponse.videos.items.length > 0) {
    videoLink = apiResponse.videos.items[0].url;
  }
  
  // Check for audios array
  if (apiResponse.audios?.items && apiResponse.audios.items.length > 0) {
    audioLink = apiResponse.audios.items[0].url;
  }
  
  // Fallback to direct properties
  if (!videoLink) {
    videoLink = apiResponse.link || apiResponse.url || apiResponse.downloadUrl || null;
  }
  
  if (!audioLink) {
    audioLink = videoLink;
  }
  
  console.log('Extracted video link:', videoLink);
  console.log('Extracted audio link:', audioLink);
  
  return {
    videoUrl: videoLink,
    title: title,
    thumbnail: thumbnail,
    author: author,
    duration: apiResponse.lengthText || apiResponse.duration || '',
    videoId: videoId,
    quality: apiResponse.videos?.items?.[0]?.quality || 'HD',
    // Map to match TikTok structure for VideoResult component
    coverImage: thumbnail,
    description: title,
    musicUrl: audioLink,
    avatarThumb: null,
    region: 'YouTube',
    isVideo: true
  };
};
